const trackEvent = (eventName, payload = {}) => {
  if (!window.dataLayer) {
    console.log("DataLayer is not initialized.");
    return;
  }

  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: eventName,
    user_id: localStorage.getItem("user_id"),
    ...payload,
  });
};

export default trackEvent;